import { useEffect, useRef } from 'react';

/**
 * Custom hook to track time spent on a page
 * @param callback - Function to execute when the user leaves the page
 */
export const useTrackTimeSpent = (callback: (timeSpent: number) => void) => {
  const startTimeRef = useRef(Date.now());

  useEffect(() => {
    const handleBeforeUnload = () => {
      const timeSpent = (Date.now() - startTimeRef.current) / 1000; // Convert ms to seconds
      callback(timeSpent);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [callback]);
};
